(() => {
  if (window.BenchmarkCartCountLoaded) return;

  window.BenchmarkCartCountLoaded = true;

  const selector = '[data-benchmark-cart-count]';
  const storageKey = 'cart-count';
  const currentScript = document.currentScript;

  const normalizeCachedLinks = () => {
    document.querySelectorAll('a[href="/cart"], a[href="/cart?view=benchmark"]').forEach((link) => {
      link.setAttribute('href', '/cart?view=cartrecs');
    });

    document.querySelectorAll('a[href="/collections/all"]').forEach((link) => {
      link.setAttribute('href', '/collections/all?view=benchmark');
    });

    document.querySelectorAll('a[href="/collections/first-aid"]').forEach((link) => {
      link.setAttribute('href', '/collections/first-aid?page=1');
    });

    document.querySelectorAll('a[href="/collections/storage-organisation"]').forEach((link) => {
      link.setAttribute('href', '/collections/storage-organisation?page=1');
    });
  };

  const redirectCachedCollectionPage = () => {
    const staleCollectionPaths = new Set(['/collections/first-aid', '/collections/storage-organisation']);

    if (!staleCollectionPaths.has(window.location.pathname) || window.location.search) return;

    window.location.replace(`${window.location.pathname}?page=1`);
  };

  const toCount = (value) => {
    const count = Number.parseInt(value, 10);
    return Number.isFinite(count) && count > 0 ? count : 0;
  };

  const getCurrentCount = () => toCount(document.querySelector(selector)?.textContent);

  const updateBadges = (count) => {
    const nextCount = toCount(count);

    document.querySelectorAll(selector).forEach((badge) => {
      badge.textContent = nextCount > 99 ? '99+' : String(nextCount);
      badge.setAttribute('aria-label', `${nextCount} items in cart`);
    });

    try {
      sessionStorage.setItem(
        storageKey,
        JSON.stringify({
          value: String(nextCount),
          timestamp: Date.now(),
        })
      );
    } catch (_) {
      // Storage can be unavailable in strict browser modes.
    }
  };

  const syncFromCart = async () => {
    if (!document.querySelector(selector)) return;

    try {
      const response = await fetch('/cart.js', {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      });

      if (!response.ok) return;

      const cart = await response.json();
      updateBadges(cart.item_count);
    } catch (_) {
      // If the network request fails, leave the server-rendered count in place.
    }
  };

  const loadCartRecommendations = () => {
    if (!window.location.pathname.endsWith('/cart')) return;
    if (window.BenchmarkCartRecommendationsRequested) return;
    if (customElements.get('benchmark-cart-recommendations')) return;

    const sourceScript =
      currentScript ||
      Array.from(document.scripts).find((script) => script.src.includes('benchmark-cart-count.js'));

    if (!sourceScript?.src) return;

    window.BenchmarkCartRecommendationsRequested = true;

    const script = document.createElement('script');
    script.src = sourceScript.src.replace('benchmark-cart-count.js', 'benchmark-cart-recommendations.js');
    script.defer = true;
    document.head.appendChild(script);
  };

  document.addEventListener('cart:update', (event) => {
    const data = event.detail?.data;

    if (data?.didError) {
      syncFromCart();
      return;
    }

    if (typeof data?.itemCount !== 'number') {
      syncFromCart();
      return;
    }

    const count =
      data.source === 'product-form-component' ? getCurrentCount() + data.itemCount : data.itemCount;

    updateBadges(count);
  });

  window.addEventListener('pageshow', syncFromCart);

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        normalizeCachedLinks();
        redirectCachedCollectionPage();
        loadCartRecommendations();
        syncFromCart();
      },
      { once: true }
    );
  } else {
    normalizeCachedLinks();
    redirectCachedCollectionPage();
    loadCartRecommendations();
    syncFromCart();
  }
})();
